import React, { useEffect } from 'react';
import Hero from '../components/hero/Hero';
import Aboutus from '../components/about/Aboutus';
import KeyTenets from '../components/keytenets/KeyTenets';
import How from '../components/how/How';
import Vision from '../components/vision/Vision';
import Contact from '../components/contact/Contact';

const Home = () => {
  useEffect(() => {
    if (window.location.hash) {
      const element = document.querySelector(window.location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <main className="cb-home-main">
      <Hero />
      <Aboutus />
      <KeyTenets />
      <How />
      <Vision />
      <Contact />
    </main>
  );
};

export default Home;